module.exports = __webpack_public_path__ + "img/quanqiu.986e6e9d.png";